<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Reportes
      b-col(md="auto")
        b-dropdown(variant="primary", text="Generar reporte", no-caret, right, ref="generate_report_button")
          template(slot="button-content")
            .d-flex.align-items-center.justify-content-between
              span.text-left.text-nowrap Generar reporte
              chevron-down-icon.icon-md.ml-2
          b-dropdown-header
            p.text-secondary Generar reporte para la plataforma seleccionada:
            .text-help
              alert-circle-icon.icon-md.mr-1
              span Los reportes pueden tardar varios minutos en generarse.
              br
              span Se te notificará a tu correo electrónico cuando se generen.
          template(v-if="$can('create', 'report')")
            b-dropdown-header Generar reporte de:
            b-dropdown-item(@click="openReportModal('flows')") Conversaciones
            b-dropdown-item(@click="openReportModal('wa-templates')", v-if="has_whats_official") Mensajes de plantilla
            b-dropdown-item(@click="openReportModal('metrics')", v-if="$can('read', 'report')") Métricas
            b-dropdown-item(@click="openReportModal('flows_texts')", v-if="$can('read', 'report')") Texto de flujos
            b-dropdown-item(@click="openReportModal('users')") Usuarios
            b-dropdown-item(@click="openReportModal('cases')") Casos
            b-dropdown-item(@click="openReportModal('orders')") Ventas
            b-dropdown-item(@click="openReportModal('objectives')") Objetivos
            b-dropdown-item(@click="openReportModal('no_answer')") Mensajes sin respuesta
            b-dropdown-item(@click="openReportModal('activity_record')") Registro de Actividad
            b-dropdown-item(@click="openReportModal('responses')") Respuestas del bot
    platforms-tabs.mb-3(:active="platform", @click:active="platform = $event")
    b-progress.mt-3(animated, striped, :value="progress", v-if="progress")
    b-card(no-body, style="width:100%;")
      b-table.card-table.mb-0(:items="sortedReports", :fields="fields", show-empty)
        template(v-slot:empty)
          p.mb-0.text-secondary No hay reportes disponibles
        template(v-slot:cell(name)="{ item }")
          p.mb-0 {{ item.name }}
          p.mb-0.text-secondary.text-sm Reporte de {{ getReportName(item.type) }}
          //b-link.text-sm.d-inline-flex.align-items-center.mt-1(@click="downloadFile(item.url, 'reporte')")
          b-link.text-sm.d-inline-flex.align-items-center.mt-1(:href="item.url", :download="item.name")
            download-icon.icon-sm.mr-1
            span Descargar
        template(v-slot:cell(createdAt)="{ item }")
          p.mb-0.text-secondary {{ $moment(item.createdAt).format('DD MMMM YYYY, HH:mm A') }}
    .d-flex.align-items-center.mb-3
      b-pagination.mb-0.mr-3(:value="paginationCurrentPage", @change="loading = true;paginationPageChanged($event, 'getReports')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount", v-if="v_paginationShow")
      b-spinner(small, variant="primary", v-if="loading")

    b-modal(v-model="newReportModal", ok-title="Generar reporte", ok-variant="success", cancel-title="Cancelar", title="Generar reporte", @ok="createReport", @hidden="selected_attributes = []")
      div.order
        h5.mb-3 Nuevo reporte de {{ getReportName(new_report_type) }}
        span.mb-2(v-if="getReportName(new_report_type) == 'Objetivos'") Objetivo:
        k-select.mb-2(v-if="getReportName(new_report_type) == 'Objetivos'", :options="objectives", placeholder="- Seleccionar objetivo -", :searchable="true", @input="objectiveId = $event", :clearable="true")
        span.mb-2 Rango de tiempo:
        date-range-picker.mb-3(v-bind="calendar_props", v-model="dates", :maxDate="$moment().format()")
          template.w-100(v-slot:input="picker")
            b-input-group
              b-form-input.readonly-white(placeholder="Seleccionar fecha...", :value="parse_dates", readonly)
              b-input-group-append
                b-input-group-text
                  calendar-icon.text-secondary.icon-sm
        span(v-if="new_report_type == 'cases'") Grupo:
          k-select.mt-2(:options="groups", placeholder="- Seleccionar grupo -", @input="groupId = $event", :clearable="true")
        div(v-if="new_report_type === 'orders'")
          b-form-group(size="sm", label="Estatus:")
            b-form-select(v-model="selectedOrderStatus", :options="orderStatus")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import PlatformsTabs from '@/components/PlatformsTabs.vue'
import Days from '@/data/days'
import Download from 'downloadjs'
import Months from '@/data/months'
import Select from '@/components/Select.vue'

const accountController = createNamespacedHelpers('account')
const reportController = createNamespacedHelpers('report')
const platformController = createNamespacedHelpers('platform')
const NO_SELECTED_REPORT = 'Selecciona al menos una variable para el reporte.'

export default {
  data () {
    return {
      groups: [],
      objectives: [],
      checkpoints: [],
      fields: [
        {
          key: 'name',
          label: 'Reporte'
        },
        {
          key: 'createdAt',
          label: 'Fecha de creación'
        }
      ],
      groupId: null,
      objectiveId: null,
      rangePicked: '',
      rangeParams: {
        format: 'DD MMMM YYYY',
        firstDay: 0
      },
      downloading: false,
      progress: 0,
      new_report_type: '',
      newReportModal: false,
      new_custom_report_modal: false,
      platform: 'all',
      selectedOrderStatus: 'all',
      orderStatus: [
        { value: 'all', text: 'Todas' },
        { value: 'process', text: 'Procesadas' },
        { value: 'sent', text: 'Enviadas' },
        { value: 'delivered', text: 'Entregadas' },
        { value: 'canceled', text: 'Canceladas' },
        { value: 'paid', text: 'Pagadas' },
      ],
      // orderStatusCustom: 'all',
      selected_attributes: [],
      search_attr: '',
      custom_report: {
        name: '',
        type: 'flows',
        fields: [],
        time: 'current_week',
        validated: false
      },
      report_types: [
        {
          text: 'Conversaciones',
          value: 'flows'
        },
        {
          text: 'Métricas',
          value: 'metrics',
          resource: 'report'
        },
        {
          text: 'Texto de flujos',
          value: 'flows_texts',
          resource: 'report'
        },
        {
          text: 'Usuarios',
          value: 'users'
        },
        {
          text: 'Casos',
          value: 'cases'
        },
        {
          text: 'Ventas',
          value: 'orders'
        },
        {
          text: 'Objetivos',
          value: 'objectives'
        },
      ],
      time_presets: [
        {text: 'Semana actual', value: 'current_week'},
        {text: 'Últimos 7 días', value: 'last_week'},
        {text: 'Mes actual', value: 'current_month'},
        {text: 'Últimos 30 días', value: 'last_month'}
      ],
      loading: false,
      calendar_props: {
        linkedCalendars: false,
        showDropdowns: true,
        ranges: false,
        opens: 'right',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        },
        //parentEl: 'modal-body'
      },
      dates: {
        startDate: null,
        endDate: null,
      },
    }
  },
  computed: {
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    has_whats_official () {
      return this.platforms.find(({ name }) => name === 'whatsapp_official')
    },
    ...reportController.mapState({
      reports: state => state.reports,
      custom_reports: state => state.custom_reports
    }),
    ...accountController.mapState({
      attributes: state => state.attrs
    }),
    sortedReports () {
      return this.reports.filter(el => !!el.url).sort((a, b) => {
        return this.$moment(b.createdAt).unix() - this.$moment(a.createdAt).unix()
      })
    },
    parsedAttributes () {
      return this.attributes
        .filter(a => Boolean(a.user_attribute_id) && Boolean(a.is_important))
        .map(({ name }) => {
          return { text: name, value: name }
        })
        .filter(a => !this.search_attr || a.text.search(new RegExp(this.search_attr, 'gmi')) >= 0)
    },
    attrs_indeterminate () {
      return (this.selected_attributes.length && this.parsedAttributes.length)
        ? this.selected_attributes.length !== this.parsedAttributes.length
        : false
    },
    attrs_custom_indeterminate () {
      return (this.custom_report.fields.length && this.parsedAttributes.length)
        ? this.custom_report.fields.length !== this.parsedAttributes.length
        : false
    },
    parse_dates () {
      return this.$moment(this.dates.startDate).format('DD MMM YYYY') +
        ' - ' +
        this.$moment(this.dates.endDate).format('DD MMM YYYY')
    },
  },
  methods: {
    ...mapActions([
      'report/all',
      'report/create',
      'report/all_custom',
      'report/create_custom',
      'account/attributes',
      'group/all',
      'objective/all'
    ]),
    getGroups() {
      this['group/all']({
        account_id: this.$route.params.account_id,
        callback: res => {
          if (res.error) return this.$message.error(res.error)

          res.resource.unshift({ name: 'Todos los grupos', group_id: 0 })

          this.groups = res.resource.map(({ name: label, group_id: id }) => {
            return { label, id }
          })
        }
      })
    },
    getObjectives() {
      this['objective/all']({
        account_id: this.$route.params.account_id,
        callback: res => {
          if (res.error) return this.$message.error(res.error)

          this.objectives = res.resource.map(({ name: label, _id: id }) => {
            return { label, id }
          })
        }
      })
    },
    getAttributes() {
      this['account/attributes']({
        account_id: this.$route.params.account_id,
        params: { is_important: true },
        callback: res => {
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    getReports() {
      const self = this
      this.loading = true

      this['report/all']({
        account_id: self.$route.params.account_id,
        params: {
          platform: self.platform,
          ...self.paginationParamsObject
        },
        callback: res => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.parsePaginationDataFromResponse(res)
        }
      })
    },
    getCustomReports() {
      const self = this

      this['report/all_custom']({
        account_id: self.$route.params.account_id,
        params: { platform: self.platform },
        callback: res => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    createReport(customReport) {
      let data = {}

      if (this.new_report_type === 'custom') {
        data = {
          account_id: this.$route.params.account_id,
          custom_report_id: customReport.custom_report_id,
          platform: this.platform
        }
      } else {
        data = {
          account_id: this.$route.params.account_id,
          type: this.new_report_type,
          group_id: this.groupId == 0 ? null : this.groupId,
          objective_id: this.objectiveId == 0 ? null : this.objectiveId,
          init_date: this.$moment(this.dates.startDate).startOf('d').format(),
          final_date: this.$moment(this.dates.endDate).endOf('d').format(),
          platform: this.platform
        }

        if (
          this.new_report_type === 'orders' &&
          this.selectedOrderStatus &&
          this.selectedOrderStatus !== 'all'
        ) {
          data.status = this.selectedOrderStatus
        }
      }

      this['report/create']({
        ...data,
        callback: res => {
          if (res.error) return this.$message.error(res.error)

          const message = `Se está creando el reporte y puede tardar unos segundos. \n
          Una vez completado se enviará a tu correo electrónico y aparecerá listado después de refrescar la página.`

          this.$bvModal.msgBoxOk(
            message,
            {
              title: 'Reporte generado',
              centered: true,
              okVariant: 'success',
              okTitle: 'Entendido'
            }
          )
        }
      })
    },
    createCustomReport (event) {
      const self = this
      const fields = ['name', 'time', 'type', 'fields']

      for (const key of fields) {
        this.custom_report.validated = true

        if (key === 'fields') {
          if (!this.custom_report.fields.length) {
            event.preventDefault()
            return
          }
        } else {
          if (!this.custom_report[key]) {
            event.preventDefault()
            return
          }
        }
      }

      const json_data = {
        account_id: self.$route.params.account_id,
        ...self.custom_report,
        platform: self.platform
      }

      this['report/create_custom']({
        ...json_data,
        callback: res => {
          if (res.error) return self.$message.error(res.error)

          self.$message.success('Reporte personalizado creado con éxito')
          self.getCustomReports()
          self.$refs['generate_report_button'].show()
        }
      })
    },
    async downloadFile (url, name) {
      this.downloading = true

      const x = new XMLHttpRequest()

      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function(e) {
        Download(e.target.response, name, x.getResponseHeader("content-type"))
      }
      x.send()

      this.downloading = false
    },
    openReportModal (type, customReport) {
      this.new_report_type = type
      const types = ['custom', 'flows_texts']

      if (types.includes(type)) {
        this.confirmCreateReport(
          type,
          type === 'custom' ? customReport : undefined
        )
      } else {
        this.newReportModal = true
      }
    },
    getReportName (type) {
      const typeMapping = {
        'flows_texts': 'Texto de flujos',
        'metrics': 'Métricas',
        'flows': 'Flujos',
        'users': 'Usuarios',
        'cases': 'Cases',
        'orders': 'Ventas',
        'objectives': 'Objetivos',
        'no_answer': 'Mensajes sin respuesta',
        'activity_record': 'Registro de Actividad',
        'responses': 'Respuestas del bot',
      }

      return typeMapping[type] || type
    },
    selectAll (event = true, type) {
      if (type === 'custom') {
        if (event) {
          this.custom_report.fields = this.parsedAttributes.map(a => a.value)
        } else {
          this.custom_report.fields = []
        }
      } else {
        if (event) {
          this.selected_attributes = this.parsedAttributes.map(a => a.value)
        } else {
          this.selected_attributes = []
        }
      }
    },
    resetCustomReport () {
      this.custom_report = {
        name: '',
        type: 'flows',
        fields: [],
        time: 'current_week',
        validated: false
      }
    },
    confirmCreateReport (type, customReport) {
      const self = this

      const message =
        (type === 'custom')
          ? `¿Deseas crear el reporte ${customReport.name}?`
          : `¿Deseas crear un reporte de ${this.getReportName(this.new_report_type)}?`

      this.$bvModal.msgBoxConfirm(message, {
        title: 'Crear reporte',
        okVariant: 'success',
        okTitle: 'Crear reporte',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value) self.createReport(customReport)
      })
    }
  },
  mounted () {
    this.getReports()
    this.getCustomReports()
    this.getAttributes()
    this.getGroups()
    this.getObjectives()

    this.dates.startDate = this.$moment().subtract(1, 'M').format();
    this.dates.endDate = this.$moment().format()
  },
  watch: {
    platform (value) {
      if (value) {
        this.getReports()
        this.getCustomReports()
      }
    }
  },
  components: {
    PlatformsTabs,
    'k-select': Select
  }
}
</script>

<style lang="scss" scoped>
  .scrollable-container-sm {
    max-height: 250px;
    overflow: hidden;
    overflow-y: auto;
    word-break: break-all;
  }

  .order {
    display: flex;
    flex-direction: column !important;
  }
</style>
